// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableWrapper__xGn48 {
  width: 100%;
  max-width: 100%;
  overflow: auto;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--table-box-shadow);
}
.tableWrapper__xGn48::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.tableWrapper__xGn48::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.tableWrapper__xGn48::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.tableWrapper__xGn48::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.facilityGroupsTable__NHFNs {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
}
.facilityGroupsTable__NHFNs .facilityGroupsTableHeader__XX4x_ th {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-align: left;
  text-wrap: nowrap;
  position: sticky;
  top: 0;
  z-index: 2;
}
.facilityGroupsTable__NHFNs tr:not(.detailsRow__G4moH, .emptyRow__pHs9y):hover td {
  background: var(--tables-primary-row-surface-hover);
}
.facilityGroupsTable__NHFNs td {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  transition: all 150ms ease-in-out;
}

.thWithDetails__MTx5e {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 36px;
}

.trWithDetails__LdgNw {
  position: sticky;
  top: 45px;
  z-index: 1;
}

.tdWithDetails__P42TU {
  font-size: 11px;
  font-weight: 600;
  line-height: 12px;
  color: var(--tables-secondary-row-sub-title-text);
  text-transform: uppercase;
  display: grid;
  grid-template-columns: 16px auto;
  align-items: center;
  column-gap: 5px;
  padding-top: 17px;
  padding-bottom: 17px;
  padding-left: 15px;
  cursor: pointer;
}

.arrowDetailsIcon__KFm6g {
  width: 16px;
  height: 16px;
  transition: all 0.3s ease-in-out;
  transform: rotate(180deg);
}
.arrowDetailsIcon__KFm6g path {
  stroke: var(--tables-secondary-row-sub-title-icon);
}

.arrowTop__RHvqy {
  transform: rotate(0);
}

.actionColumn__hByfa {
  padding-right: 15px !important;
  width: 50px;
}

.actionsIconContainer__jcv3C {
  width: 24px;
  margin-left: auto;
  -webkit-user-select: none;
          user-select: none;
  text-align: center;
  cursor: pointer;
  outline: none;
}

.detailsRow__G4moH {
  display: contents;
}
.detailsRow__G4moH > td {
  padding: 15px;
  background-color: var(--tables-secondary-row-sub-title-surface);
}

.emptyRow__pHs9y {
  height: 300px;
}

.skeletonText__k3iFp {
  width: 400px;
  height: 12px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageFacility/components/TableFacilityGroups/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,eAAA;EACA,cAAA;EACA,qDAAA;EACA,mCAAA;AAzEF;AAoBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,+BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,8BAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,kBAAA;AArBJ;;AA4DA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAzDF;AA4DI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,mDAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AA1DN;AA+DI;EACE,mDAAA;AA7DN;AAiEE;EACE,yDAAA;EACA,qDAAA;EACA,iCAAA;AA/DJ;;AAmEA;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;AAhEF;;AAmEA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAhEF;;AAmEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,yBAAA;EACA,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;AAhEF;;AAmEA;EACE,WAAA;EACA,YAAA;EACA,gCAAA;EACA,yBAAA;AAhEF;AAkEE;EACE,kDAAA;AAhEJ;;AAoEA;EACE,oBAAA;AAjEF;;AAoEA;EACE,8BAAA;EACA,WAAA;AAjEF;;AAoEA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAjEF;;AAoEA;EACE,iBAAA;AAjEF;AAmEE;EACE,aAAA;EACA,+DAAA;AAjEJ;;AAqEA;EACE,aAAA;AAlEF;;AAqEA;EACE,YAAA;EACA,YAAA;AAlEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.tableWrapper {\n  width: 100%;\n  max-width: 100%;\n  overflow: auto;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--table-box-shadow);\n  @include scrollBar;\n}\n\n.facilityGroupsTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n\n  .facilityGroupsTableHeader {\n    th {\n      font-size: 11px;\n      font-weight: 400;\n      line-height: 14px;\n      text-transform: uppercase;\n      color: var(--tables-title-text);\n      border-bottom: 1px solid var(--tables-title-stroke);\n      background: var(--tables-title-surface);\n      text-align: left;\n      text-wrap: nowrap;\n      position: sticky;\n      top: 0;\n      z-index: 2;\n    }\n  }\n\n  tr:not(.detailsRow, .emptyRow):hover {\n    td {\n      background: var(--tables-primary-row-surface-hover);\n    }\n  }\n\n  td {\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-default);\n    transition: all 150ms ease-in-out;\n  }\n}\n\n.thWithDetails {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  padding-left: 36px;\n}\n\n.trWithDetails {\n  position: sticky;\n  top: 45px;\n  z-index: 1;\n}\n\n.tdWithDetails {\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 12px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-transform: uppercase;\n  display: grid;\n  grid-template-columns: 16px auto;\n  align-items: center;\n  column-gap: 5px;\n  padding-top: 17px;\n  padding-bottom: 17px;\n  padding-left: 15px;\n  cursor: pointer;\n}\n\n.arrowDetailsIcon {\n  width: 16px;\n  height: 16px;\n  transition: all 0.3s ease-in-out;\n  transform: rotate(180deg);\n\n  path {\n    stroke: var(--tables-secondary-row-sub-title-icon);\n  }\n}\n\n.arrowTop {\n  transform: rotate(0);\n}\n\n.actionColumn {\n  padding-right: 15px !important;\n  width: 50px;\n}\n\n.actionsIconContainer {\n  width: 24px;\n  margin-left: auto;\n  user-select: none;\n  text-align: center;\n  cursor: pointer;\n  outline: none;\n}\n\n.detailsRow {\n  display: contents;\n\n  & > td {\n    padding: 15px;\n    background-color: var(--tables-secondary-row-sub-title-surface);\n  }\n}\n\n.emptyRow {\n  height: 300px;\n}\n\n.skeletonText {\n  width: 400px;\n  height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `tableWrapper__xGn48`,
	"facilityGroupsTable": `facilityGroupsTable__NHFNs`,
	"facilityGroupsTableHeader": `facilityGroupsTableHeader__XX4x_`,
	"detailsRow": `detailsRow__G4moH`,
	"emptyRow": `emptyRow__pHs9y`,
	"thWithDetails": `thWithDetails__MTx5e`,
	"trWithDetails": `trWithDetails__LdgNw`,
	"tdWithDetails": `tdWithDetails__P42TU`,
	"arrowDetailsIcon": `arrowDetailsIcon__KFm6g`,
	"arrowTop": `arrowTop__RHvqy`,
	"actionColumn": `actionColumn__hByfa`,
	"actionsIconContainer": `actionsIconContainer__jcv3C`,
	"skeletonText": `skeletonText__k3iFp`
};
module.exports = ___CSS_LOADER_EXPORT___;
